import type { GeneratorConfig } from './types';

export const RESOLUTION_PRESETS = [
  { label: 'Custom', width: 0, height: 0 },
  { label: 'HD · 16:9', width: 1280, height: 720 },
  { label: 'WXGA · 16:10', width: 1280, height: 800 },
  { label: 'Full HD · 16:9', width: 1920, height: 1080 },
  { label: 'WUXGA · 16:10', width: 1920, height: 1200 },
  { label: '4K UHD · 16:9', width: 3840, height: 2160 },
  { label: '4K · 16:10', width: 3840, height: 2400 },
  { label: 'DCI 4K', width: 4096, height: 2160 },
] as const;

export const LED_COLOR_PRESETS = [
  { id: 'gray-magenta', label: 'Gray / Magenta', a: '#626b78', b: '#d946ef' },
  { id: 'gray-cyan', label: 'Gray / Cyan', a: '#626b78', b: '#22d3ee' },
  { id: 'gray-dark-green', label: 'Gray / Dark green', a: '#626b78', b: '#166534' },
  { id: 'gray-lime', label: 'Gray / Lime', a: '#626b78', b: '#84cc16' },
  { id: 'gray-red', label: 'Gray / Red', a: '#626b78', b: '#ef4444' },
  { id: 'gray-orange', label: 'Gray / Orange', a: '#626b78', b: '#ff8040' },
  { id: 'graphite-amber', label: 'Graphite / Amber', a: '#343a40', b: '#ffb000' },
  { id: 'slate-electric-blue', label: 'Slate / Electric blue', a: '#475569', b: '#2684ff' },
  { id: 'charcoal-warm-white', label: 'Charcoal / Warm white', a: '#292d32', b: '#e8e1d5' },
  { id: 'navy-gold', label: 'Navy / Gold', a: '#1c2a3a', b: '#f2c14e' },
  { id: 'custom', label: 'Custom', a: '#626b78', b: '#d946ef' },
] as const;

export const PROJECTION_COLOR_PRESETS = [
  {
    id: 'technical-dark',
    label: 'Technical dark',
    backgroundA: '#101419',
    backgroundB: '#343b44',
    grid: '#f4f7fa',
    overlay: '#24c8db',
  },
  {
    id: 'blueprint',
    label: 'Blueprint',
    backgroundA: '#0b2535',
    backgroundB: '#123d55',
    grid: '#a8e3f0',
    overlay: '#ffffff',
  },
  {
    id: 'neutral-warm',
    label: 'Neutral warm',
    backgroundA: '#34383d',
    backgroundB: '#595d62',
    grid: '#f3ebdd',
    overlay: '#ff8040',
  },
  {
    id: 'light-calibration',
    label: 'Light calibration',
    backgroundA: '#d8dadf',
    backgroundB: '#f2f3f5',
    grid: '#31363c',
    overlay: '#e04444',
  },
  {
    id: 'cinema-black',
    label: 'Cinema black',
    backgroundA: '#07090c',
    backgroundB: '#171b20',
    grid: '#8b949e',
    overlay: '#ffb000',
  },
  {
    id: 'custom',
    label: 'Custom',
    backgroundA: '#101419',
    backgroundB: '#343b44',
    grid: '#f4f7fa',
    overlay: '#24c8db',
  },
] as const;

export const DEFAULT_CONFIG: GeneratorConfig = {
  schemaVersion: 1,
  title: 'Main Screen',
  mode: 'led',
  displayUnit: 'mm',
  projection: {
    resolution: { width: 1920, height: 1080 },
    physical: { widthMm: 6000, heightMm: 3375 },
    colorPreset: 'technical-dark',
    gridStepMm: 500,
    gridColor: '#f4f7fa',
    gridLineWidth: 2,
    backgroundMode: 'solid',
    backgroundColorA: '#101419',
    backgroundColorB: '#343b44',
    showDiagonals: true,
    showCenter: true,
    showCircle: true,
    overlayColor: '#24c8db',
    overlayLineWidth: 2,
  },
  led: {
    cabinetResolution: { width: 512, height: 512 },
    cabinetPhysical: { widthMm: 500, heightMm: 500 },
    columns: 8,
    rows: 4,
    gridColor: '#ffffff',
    backgroundColorA: '#626b78',
    backgroundColorB: '#d946ef',
    colorPreset: 'gray-magenta',
    showCoordinates: true,
    coordinateColor: '#ffffff',
  },
  power: {
    lineColor: '#ffd43b',
    lineWidth: 18,
    incoming: true,
    cableLabel: 'PWR-01',
    routes: [],
  },
  label: {
    enabled: true,
    textColor: '#ffffff',
    fontSize: 54,
    backgroundColor: '#05070a',
    backgroundOpacity: 0.72,
  },
  logo: {
    dataUrl: null,
    fileName: null,
    scale: 0.1,
    opacity: 1,
  },
};
